export default __webpack_public_path__ + "static/media/tshirtTemplateBGFilled-sm.012248bd.webp";